'use client';

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { useEffect, useState } from 'react';
import FeaturesCarousel from './FeaturesCarousel';
import {
  getUserConfigFromLocal,
  setUserConfigToLocal,
} from '@/utils/get-user-config';

const WelcomeModal = () => {
  const [open, setOpen] = useState(false);

  const handleChange = async (open: boolean) => {
    if (!open) {
      setUserConfigToLocal({ dismissedWelcomeBanner: true });
    }
    setOpen(open);
  };

  useEffect(() => {
    const showIfNotAlreadyDismissed = async () => {
      const { data: userConfig } = await getUserConfigFromLocal();
      if (!userConfig?.dismissedWelcomeBanner) {
        setOpen(true);
      }
    };

    showIfNotAlreadyDismissed();
  }, []);

  return (
    <Dialog open={open} onOpenChange={handleChange}>
      <DialogTitle className="sr-only">{'Welcome to GitExamples!'}</DialogTitle>
      <DialogContent className="mx-auto max-w-[90vw] overflow-hidden sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl">
        <FeaturesCarousel onClose={handleChange} />
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
